import React, { useEffect, useState } from "react";
import "../../styles/CreateCameraGroup.css";
import CameraGridSection from "../../ui/custom-card";
import { CreateCameraGroupApi, fetchCameralistingApi } from "../../api/api";
import CustomButton from "../../ui/custom-button";
import { PulseLoader } from "react-spinners";
import { CiEdit } from "react-icons/ci";
import Dropdown from "react-bootstrap/Dropdown";
import { MdCheckBoxOutlineBlank, MdOutlineGridOn } from "react-icons/md";
import { LuGrid2X2 } from "react-icons/lu";
import { BsGrid3X2 } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";
import { SetGroupData } from "../../store/reducer/livefeed";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const CreateCameraGroup = () => {
  const navigate = useNavigate();
  const [selectedImages, setSelectedImages] = useState([]);
  const [cameraStreams, setCameraStreams] = useState([]);
  //console.log("cameraStreams", cameraStreams);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(6);
  const [total, setTotal] = useState(0);
  const [isEditingName, setIsEditingName] = useState(false);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [msg, setmsg] = useState("");
  const { groupName, groupImage } = useSelector(
    (state) => state?.LiveFeed?.data
  );
  const { user_id, organization_id } = useSelector(
    (state) => state?.authUser?.data?.data
  );

  //console.log("groupName", groupName);

  useEffect(() => {
    setCameraStreams([]);
    const fetchCamera = async () => {
      try {
        const res = await fetchCameralistingApi(
          page,
          limit,
          null,
          user_id,
          organization_id
        );
        if (res?.data?.status === true) {
          setCameraStreams(res?.data?.data || []);
          setTotal(res?.data?.data?.total || 0);
        }
      } catch (error) {
        console.error("Error fetching cameras", error);
      }
    };
    fetchCamera();
  }, [page, limit]);

  const handleSelection = (selected) => {
    setSelectedImages(selected);
  };

  const removeImage = (img) => {
    const updated = selectedImages.filter((i) => i._id !== img._id);
    setSelectedImages(updated);
  };

  const handleSaveGroup = async () => {
    const camera_ids = selectedImages.map((cam) => cam._id);

    const payload = new FormData();
    payload.append("camera_grp_name", groupName);
    payload.append("user_id", user_id);
    payload.append("organization_id", organization_id);
    camera_ids.forEach((id) => {
      payload.append("camera_ids", id);
    });

    if (groupImage) {
      if (typeof groupImage === "string") {
        const blob = await fetch(groupImage).then((res) => res.blob());
        payload.append("thumbnail_image", blob, "group-thumbnail.png");
      } else {
        payload.append("thumbnail_image", groupImage);
      }
    }

    setLoading(true);
    try {
      const response = await CreateCameraGroupApi(payload);
      //console.log("Group created:", response);
      if (response?.data?.status === true) {
        // setmsg(response?.data?.message);
        toast(response?.data?.message);
        navigate("/camera-group");
      }
    } catch (error) {
      console.error("Failed to create group", error);
    } finally {
      setLoading(false);
    }
  };

  setTimeout(() => setmsg(""), 4000);

  const [gridDisplay, setGridDisplay] = useState({
    icon: <MdOutlineGridOn size={24} />,
    label: "1x4",
    className: "gridClass1x4",
  });

  return (
    <>
      <div className="d-flex fullHeightCst">
        <div className="leftSection">
          <div className="titleFiltrer d-flex align-items-center p-4 border-bottom bg-white">
            <div className="col-xl-7">
              <h2>Create Camera Group</h2>
            </div>
            <div className="col-xl-5">
              <div className="filterFildes">
                <select className="form-select">
                  <option>Regional ID / Location ID</option>
                </select>
                <select className="form-select">
                  <option>Locations</option>
                </select>

                <Dropdown className="cstDropDown">
                  <Dropdown.Toggle id="dropdown-basic">
                    {gridDisplay.icon} {gridDisplay.label}
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item
                      onClick={() =>
                        setGridDisplay({
                          icon: <MdCheckBoxOutlineBlank size={24} />,
                          label: "1x1",
                          className: "gridClass1x1",
                        })
                      }
                    >
                      <MdCheckBoxOutlineBlank size={24} /> 1x1
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={() =>
                        setGridDisplay({
                          icon: <LuGrid2X2 size={24} />,
                          label: "1x2",
                          className: "gridClass1x2",
                        })
                      }
                    >
                      <LuGrid2X2 size={24} /> 1x2
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={() =>
                        setGridDisplay({
                          icon: <BsGrid3X2 size={24} />,
                          label: "1x3",
                          className: "gridClass1x3",
                        })
                      }
                    >
                      <BsGrid3X2 size={24} /> 1x3
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={() =>
                        setGridDisplay({
                          icon: <MdOutlineGridOn size={24} />,
                          label: "1x4",
                          className: "gridClass1x4",
                        })
                      }
                    >
                      <MdOutlineGridOn size={24} /> 1x4
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
          </div>

          <div className={`p-4`}>
            <CameraGridSection
              images={cameraStreams}
              onSelectionChange={handleSelection}
              gridDisplaySize={gridDisplay.className}
            />
          </div>
          <div className="pagination d-flex justify-content-center mt-4 gap-3">
            <button
              className="btn btn-outline-primary"
              disabled={page === 1}
              onClick={() => setPage((prev) => prev - 1)}
            >
              Previous
            </button>
            <span className="align-self-center">
              Page {page} of {Math.ceil(total / limit)}
            </span>
            <button
              className="btn btn-outline-primary"
              disabled={page >= Math.ceil(total / limit)}
              onClick={() => setPage((prev) => prev + 1)}
            >
              Next
            </button>
          </div>
        </div>

        <div className="rightSection bg-white border-start">
          <div className="titleFiltrer p-4 border-bottom">
            <div className="d-flex align-items-center">
              {isEditingName ? (
                <>
                  <input
                    type="text"
                    className="form-control"
                    value={groupName}
                    onChange={(e) =>
                      dispatch(SetGroupData({ groupName: e.target.value }))
                    }
                    onBlur={() => setIsEditingName(false)}
                    autoFocus
                    style={{ maxWidth: 200, marginRight: 10 }}
                  />
                  <button
                    className="editIcon"
                    onClick={() => setIsEditingName(false)}
                    title="Done"
                  >
                    Add
                  </button>
                </>
              ) : (
                <>
                  <h3>{groupName || "Auditorium 1"}</h3>
                  <button
                    className="editIcon"
                    onClick={() => setIsEditingName(true)}
                    title="Edit Group Name"
                  >
                    <CiEdit size={22} />
                  </button>
                </>
              )}
            </div>
          </div>

          <div className="selectedList">
            {selectedImages?.map((cam, idx) => (
              <div key={cam._id} className="selected-image">
                <img
                  src={`https://visionemptrack.greymatterz.com/stream2/stream2/${cam._id}`}
                  alt={`Selected ${idx}`}
                />
                <span className="remove-icon" onClick={() => removeImage(cam)}>
                  −
                </span>
              </div>
            ))}
          </div>

          {selectedImages?.length > 0 ? (
            <div className="buttonGroup">
              <button className="cancelBtn">Cancel</button>
              {loading ? (
                <CustomButton type="submit" className="save-btn">
                  <PulseLoader color="#fff" />
                </CustomButton>
              ) : (
                <button className="nextBtn" onClick={handleSaveGroup}>
                  Save
                </button>
              )}
              {msg && (
                <div
                  className="api-message"
                  style={{ color: "green", marginTop: "10px", size: "100px" }}
                >
                  {msg}
                </div>
              )}
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    </>
  );
};

export default CreateCameraGroup;
